import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
//import RenderDecimalTextField from './renderDecimalTextFiel';
import { Grid, Button } from '@material-ui/core';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import renderAutoComplete from '../Complements/renderAutoComplete';
import RenderRadioGroup from '../Complements/RenderRadioGroup';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import RenderTextFieldReduxEmail from '../Complements/RenderTextFieldReduxEmail';
// import Autocomplete from '@material-ui/lab/Autocomplete';
//import { withStyles } from '@material-ui/styles';


const validate = values => {
    const error = {}

    const pattern = new RegExp('^[A-Za-z ]+$', 'i');
    const patternOnlyNumbers = new RegExp('^[0-9]+$', 'i');

    if (!values.name) {
        error.name = "El nombre es un campo obligatorio"
    }
    if (values.name) {
        if (values.name.toString().length > 30) {
            error.name = "El nombre solo permite hasta 30 carácteres."
        }
    }
    if (!pattern.test(values.name)) {
        error.name = "El nombre solo permite letras y espacios"
    }
    if (!values.email) {
        error.email = "El email es un campo obligatorio"
    }
    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        error.email = 'Correo electrónico no válido'
    }
    if (!values.number) {
        error.number = "La número de cuenta es un campo obligatorio"
    }
    if (!patternOnlyNumbers.test(values.number)) {
        error.number = "El número de cuenta solo acepta números"
    }
    if (!values.document) {
        error.document = "El tipo de identificación es obligatorio"
    }
    if (!values.cedule) {
        error.cedule = "El campo número de identificación es obligatorio"
    }
    if (!patternOnlyNumbers.test(values.cedule)) {
        error.cedule = "La identificación solo acepta números"
    }
    return error
}

/* const useStyles = () => ({
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    }
}); */

const normalizeNumber = (value) => {
    if (!value) {
        return value
    }
    const onlyNums = value.replace(/[^\d]/g, '')
    return onlyNums
}

class FavoriteCreditCardForm extends Component {
    state = {
        Radiogroup: [
            {
                id: 1,
                value: 'INTERNO',
                label: 'Interno'
            },
            {
                id: 2,
                value: 'EXTERNO',
                label: 'Externo'
            }
        ],
        internal: true,
    }
    handleEntityChange = (e) => (
        this.props.setEntity(e)
    )
    handleTypeChange = (e) => {
        this.props.setType(e)
    }
    handleInstitutionChange = (e) => (
        this.props.setInstitution(e)
    )
    render() {
        const { /* classes, */ handleSubmit, submitting, cancelPrompt, entities, document, setDocument } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <Grid container style={{ marginTop: 16, gap: 16 }}>
                    {/* <Grid item xs={12} md={12}>
                            <Field
                                    // {...this.state}
                                    withFocus
                                    name="entity"
                                    id="entity"
                                    required
                                    options = { entities.informacionInstituciones }
                                    field = { "nombre" }
                                    getData = { this.handleEntityChange }
                                    // className={clsx(classes.margin, classes.textField)}
                                    component={ renderAutoComplete }
                                    label="Tipo de Institución Financiera"
                                    fullWidth
                            />
                        </Grid> */}
                    <Grid item xs={12} md={12}>
                        <Field
                            // {...this.state}
                            name="institution"
                            id="institution"
                            required
                            options={entities.institucionTransferencias}
                            field={"institution_name"}
                            getData={this.handleInstitutionChange}
                            component={renderAutoComplete}
                            label="Nombre de Institución Financiera"
                            fullWidth
                        />
                    </Grid>
                    {/* <Grid item xs={12} md={12}>
                            <Field
                                    // {...this.state}
                                    name="type"
                                    id="type"
                                    required
                                    options = {entities.tiposCuenta}
                                    field = { "nombre" }
                                    getData = { this.handleTypeChange }
                                    component={ renderAutoComplete }
                                    label="Tipo de cuenta"
                                    fullWidth
                            />
                        </Grid> */}
                    <Grid item xs={12} md={12}>
                        <Field
                            name="document"
                            id="document"
                            required
                            row
                            data={
                                [
                                    { label: 'CÉDULA', value: '3' },
                                    { label: 'RUC', value: '1' },
                                    { label: 'PASAPORTE', value: '10' },
                                ]
                            }
                            document={document}
                            component={RenderRadioGroup}
                            label="Tipo de identificación"
                            setVal={setDocument}
                            valor={document}
                        >
                        </Field>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {(parseInt(document) === 10) ?
                            <Field
                                withFocus
                                name="cedule"
                                id="cedule"
                                required
                                // valueData = { cedule }
                                component={RenderTextFieldRedux}
                                label={'Número de identificación'}
                                type={"text"}
                                //normalize={(document === 6) ? normalizeAll : normalizeNumber}
                                fullWidth
                            /> :
                            <Field
                                withFocus
                                name="cedule"
                                id="cedule"
                                required
                                // valueData = { cedule }
                                component={RenderTextFieldRedux}
                                label={'Número de identificación'}
                                type={"text"}
                                normalize={normalizeNumber}
                                fullWidth
                                maxLength={parseInt(document) === 3 ? 10 : 13}
                            />}
                        {/* <Field
                            withFocus
                            name="cedule"
                            id="cedule"
                            required
                            // valueData = { cedule }
                            component={RenderTextFieldRedux}
                            label={'Número de identificación'}
                            type={"text"}
                            fullWidth
                        /> */}
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Field
                            withFocus
                            name="number"
                            id="number"
                            required
                            allowZero={true}
                            component={RenderTextFieldRedux}
                            label="Número de tarjeta"
                            type="text"
                            normalize={normalizeNumber}
                            fullWidth
                        /* onChange = {
                            e => console.log(e.target.value)
                        } */
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Field
                            name="name"
                            id="name"
                            required
                            component={RenderTextFieldRedux}
                            label="Nombre"
                            type="text"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Field
                            withFocus
                            name="email"
                            id="email"
                            required
                            // valueData = {email}
                            component={RenderTextFieldReduxEmail}
                            label="Correo Electrónico"
                            fullWidth
                        />
                    </Grid>
                    <Grid container justifyContent='space-evenly'>
                        <Button variant="contained" type="submit"
                            color='primary'
                            disabled={submitting}
                        >
                            Aceptar
                        </Button>

                        <Button variant="outlined"
                            onClick={cancelPrompt}
                            //className={classes.buttonStandard}

                        color={'primary'}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

const FavoriteCreditCardReduxForm = reduxForm(
    {
        form: 'FavoriteCreditCardForm',
        validate
    }
)(FavoriteCreditCardForm)
export default setPropsAsInitial(/* withStyles(useStyles) */(FavoriteCreditCardReduxForm))

// export default FavoriteCreditCardForm;
